/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypeTunnel } from './TypeTunnel';
import {
    TypeTunnelFromJSON,
    TypeTunnelFromJSONTyped,
    TypeTunnelToJSON,
    TypeTunnelToJSONTyped,
} from './TypeTunnel';

/**
 * Résultat de la duplication. Toujours HTTP 200 (hors 401/403) : l'échec se lit sur success/errorMessage.
 * 
 * @export
 * @interface DupliquerTunnelResponse
 */
export interface DupliquerTunnelResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DupliquerTunnelResponse
     */
    success: boolean;
    /**
     * Message d'échec rédigé pour l'administrateur, à afficher tel quel.
     * @type {string}
     * @memberof DupliquerTunnelResponse
     */
    errorMessage?: string | null;
    /**
     * Identifiant de la copie créée.
     * @type {string}
     * @memberof DupliquerTunnelResponse
     */
    tunnelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DupliquerTunnelResponse
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DupliquerTunnelResponse
     */
    label?: string | null;
    /**
     * Toujours false — une copie est créée désactivée.
     * @type {boolean}
     * @memberof DupliquerTunnelResponse
     */
    isActive?: boolean;
    /**
     * Type retenu pour la copie.
     * @type {TypeTunnel}
     * @memberof DupliquerTunnelResponse
     */
    tunnelType?: TypeTunnel;
    /**
     * Ce qui a suivi la copie, en clair (« 12 garanties », « 4 plateformes autorisées »). Liste dynamique : ne contient que ce qui existe sur le tunnel source. À afficher telle quelle, sans traitement par index ni par mot-clé.
     * 
     * @type {Array<string>}
     * @memberof DupliquerTunnelResponse
     */
    copied?: Array<string>;
    /**
     * Ce qui n'a pas été repris, en clair. Liste dynamique elle aussi : le changement de code et la désactivation y sont toujours présents, le reste dépend du tunnel source. À afficher telle quelle, sans traitement par index ni par mot-clé.
     * 
     * @type {Array<string>}
     * @memberof DupliquerTunnelResponse
     */
    notCopied?: Array<string>;
}



/**
 * Check if a given object implements the DupliquerTunnelResponse interface.
 */
export function instanceOfDupliquerTunnelResponse(value: object): value is DupliquerTunnelResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function DupliquerTunnelResponseFromJSON(json: any): DupliquerTunnelResponse {
    return DupliquerTunnelResponseFromJSONTyped(json, false);
}

export function DupliquerTunnelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DupliquerTunnelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'tunnelId': json['tunnelId'] == null ? undefined : json['tunnelId'],
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'tunnelType': json['tunnelType'] == null ? undefined : TypeTunnelFromJSON(json['tunnelType']),
        'copied': json['copied'] == null ? undefined : json['copied'],
        'notCopied': json['notCopied'] == null ? undefined : json['notCopied'],
    };
}

export function DupliquerTunnelResponseToJSON(json: any): DupliquerTunnelResponse {
    return DupliquerTunnelResponseToJSONTyped(json, false);
}

export function DupliquerTunnelResponseToJSONTyped(value?: DupliquerTunnelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorMessage': value['errorMessage'],
        'tunnelId': value['tunnelId'],
        'code': value['code'],
        'label': value['label'],
        'isActive': value['isActive'],
        'tunnelType': TypeTunnelToJSON(value['tunnelType']),
        'copied': value['copied'],
        'notCopied': value['notCopied'],
    };
}

